export default () => ({
	index: 0,
	setPlans(plans) {
		// save plan as session cookie
		document.cookie = `selectedPlan=${plans}; path=/;`;
	}
});
